module.exports = {"431003001":"苏仙岭街道","431003002":"南塔街道","431003003":"白鹿洞街道","431003004":"王仙岭街道","431003005":"卜里坪街道","431003006":"观山洞街道","431003101":"白露塘镇","431003102":"良田镇","431003103":"栖凤渡镇","431003104":"坳上镇","431003105":"许家洞镇","431003107":"五里牌镇","431003109":"五盖山镇","431003110":"飞天山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431003.json
// module id = 2018
// module chunks = 0